import React from 'react';
import ButtonBase from './Button.base';

const ButtonBasic = ({ title = '', action, animateTap, style, disabled = false }) => {
  return (
    <ButtonBase action={action} animateTap={animateTap} className="button--basic" style={style} disabled={disabled}>
      {title}
    </ButtonBase>
  );
};

export default ButtonBasic;
